import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  moveListElement(request: Boundaries["moveListElement"]["request"]): void;
}

function useMoveListElement(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isMoveListElementRequestPending),
    isRequestSuccess: useSelector(selector.isMoveListElementRequestSuccess),
    isRequestFailure: useSelector(selector.isMoveListElementRequestFailure),
    moveListElement: core.moveListElement,
  };
}

export { useMoveListElement };
